import { render } from "./docSupportPart.vue?vue&type=template&id=5c032cf5&scoped=true"
import script from "./docSupportPart.vue?vue&type=script&lang=js"
export * from "./docSupportPart.vue?vue&type=script&lang=js"

import "./docSupportPart.vue?vue&type=style&index=0&id=5c032cf5&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c032cf5"]])

export default __exports__